export const buildProjectUseCase = async ({
  getFreshToken,
  getEndpointUrl,
  repoName,
}) => {
  try {
    const freshToken = await getFreshToken();
    const response = await fetch(
      getEndpointUrl() + `/buildProject?repo=${repoName}`,
      {
        headers: {
          Authorization: `Bearer ${freshToken}`,
        },
      }
    );

    if (!response.ok)
      throw new Error(`Error building the React app for ${repoName}.`);

    console.log(`React app for ${repoName} has been built.`);
    return "App built successfully";
  } catch (error) {
    console.error("Error building project:", error);
    throw error;
  }
};
